var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-progress-bar round-border",class:_vm.variant,on:{"click":function($event){return _vm.$emit('progressBarClicked')}}},[_c('div',{staticClass:"progressbar round-border",class:_vm.variant,style:(_vm.width)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704288a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/trial/SimpleProgressBar.vue
// module id = null
// module chunks = 